<template>
<div>
        <v-btn @click="dialog = !dialog" color="green" dark>
            <v-icon small dark left>add_box</v-icon>
            Tạo Phiếu Mới
        </v-btn>
        <v-dialog
            v-model="dialog"
            max-width="90%"
        >
            <app-card>
                <app-section-loader :status="form_loader"></app-section-loader>
                <h4>PHIẾU THAY ĐỔI THÔNG TIN PHÒNG</h4>
                <p class="fs-14 grey--text">Tạo phiếu thay đổi thông tin phòng</p>
                <v-stepper v-model="current_step">
                    <v-stepper-header style="box-shadow: none">
                        <v-stepper-step :complete="current_step > 1" step="1">Điền thông tin thay đổi</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="current_step > 2" step="2">Tạo phiếu</v-stepper-step>
                    </v-stepper-header>
                    <hr class="mt-0">
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <app-section-loader :status="loader"></app-section-loader>
                            <v-form ref="form">
                                <v-container fluid>
                                    <p class="fs-14 grey--text">Mã chứng từ: {{ form.change_id }}</p>
                                    <v-layout row wrap justify-center>
                                        <v-flex xs12 md3>
                                            <v-select
                                                label="Tòa nhà"
                                                :disabled="loading.submit"
                                                v-model="form.building"
                                                :items="list_building"
                                                prepend-icon="domain"
                                                :rules="[rules.required]"
                                                @change="getReceiptNewestNumber"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-autocomplete
                                                label="Số phòng"
                                                :disabled="loading.submit"
                                                v-model="form.room_id"
                                                :items="room_ids"
                                                item-text="room_id"
                                                item-value="rooms_id"
                                                prepend-icon="meeting_room"
                                                :rules="[rules.required]"
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 v-if="alert.show">
                                            <v-alert
                                                :value="alert.show"
                                                :type="alert.type"
                                                outline
                                            >
                                                {{ alert.text }}
                                            </v-alert>
                                        </v-flex>
                                        <template v-if="form.room_state_id">
                                            <v-flex xs12 md3>
                                                <v-menu
                                                    :close-on-content-click="false"
                                                    v-model="menu_date_created"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                                >
                                                    <v-text-field
                                                        slot="activator"
                                                        v-model="form.date_created"
                                                        label="Ngày tạo phiếu"
                                                        :disabled="loading.submit"
                                                        prepend-icon="event"
                                                        readonly
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                    <v-date-picker
                                                      locale="vi-VI"
                                                      v-model="form.date_created"
                                                      @input="menu_date_created = false"
                                                      :max="new Date().toISOString().substr(0, 10)"
                                                      :min="blockEditDate"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex xs12 md3>
                                                <v-menu
                                                    :close-on-content-click="false"
                                                    v-model="menu_date_change"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                                >
                                                    <v-text-field
                                                        slot="activator"
                                                        v-model="form.date_change"
                                                        label="Ngày áp dụng thay đổi"
                                                        :disabled="loading.submit"
                                                        prepend-icon="event"
                                                        readonly
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                    <v-date-picker locale="vi-VI" v-model="form.date_change" @input="menu_date_change = false" :min="blockEditDate"></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <template>
                                                <v-flex xs12 md3>
                                                    <v-text-field
                                                        label="Số chứng từ giấy"
                                                        type="text"
                                                        v-model="form.paper_receipt_number"
                                                        prepend-icon="book"
                                                        :rules="[rules.required, rules.isNaturalNumber]"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-select
                                                        label="Máy lạnh"
                                                        :disabled="loading.submit"
                                                        v-model="form.air_conditioner"
                                                        :items="list_air_conditioner"
                                                        prepend-icon="ac_unit"
                                                        required
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-select
                                                        label="Máy giặt"
                                                        :disabled="loading.submit"
                                                        v-model="form.washing_machine"
                                                        :items="list_washing_machine"
                                                        prepend-icon="local_laundry_service"
                                                        required
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-select
                                                        label="Internet"
                                                        :disabled="loading.submit"
                                                        v-model="form.internet"
                                                        :items="list_internet"
                                                        prepend-icon="wifi"
                                                        required
                                                    ></v-select>
                                                </v-flex>
                                                <!-- <v-flex xs12 md3>
                                                    <v-text-field
                                                        label="Giá tiền mạng"
                                                        v-model.lazy="form.internet_data.price"
                                                        :disabled="!form.internet || loading.submit"
                                                        prepend-icon="attach_money"
                                                    >
                                                        <template slot="append">
                                                            VND
                                                        </template>
                                                    </v-text-field>
                                                </v-flex> -->
                                                <v-flex xs12 class="text-left">
                                                    <v-btn
                                                        :loading="loading.submit"
                                                        :disabled="loading.submit"
                                                        @click="addMember"
                                                        flat
                                                        color="primary"
                                                    >
                                                        Thêm thành viên mới
                                                        <v-icon right dark>add</v-icon>
                                                    </v-btn>
                                                </v-flex>
                                                <template v-for="(member, index) in form.customers">
                                                    <v-flex :key="`button ${index + 1}`" xs1>
                                                        <div class="d-flex align-items-center">
                                                            <v-btn v-if="!member.is_deleted" @click="removeMember(index)" color="red" flat depressed medium>
                                                                <v-icon class="mb-2">delete</v-icon>
                                                            </v-btn>
                                                            <v-btn v-else @click="undoRemove(index)" color="accent" flat depressed medium>
                                                                <!-- <v-icon class="mb-2">delete</v-icon> -->
                                                                Hoàn tác
                                                            </v-btn>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex :key="`name ${index + 1}`" xs12 md3>
                                                        <v-text-field
                                                            :label="`Họ tên thành viên #${index + 1}`"
                                                            :disabled="loading.submit || member.is_deleted"
                                                            v-model="member.name"
                                                            prepend-icon="account_box"
                                                            required
                                                            :rules="[rules.required]"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex :key="`contact_phone ${index + 1}`" xs12 md3>
                                                        <v-text-field
                                                            :label="`Số điện thoại #${index + 1}`"
                                                            :disabled="loading.submit || member.is_deleted"
                                                            v-model="member.phone"
                                                            prepend-icon="contact_phone"
                                                            required
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex :key="`motorbike ${index + 1}`" xs12 md3>
                                                        <v-text-field
                                                            :label="`Biển số xe #${index + 1}`"
                                                            :disabled="loading.submit || member.is_deleted"
                                                            v-model="member.motorbike"
                                                            prepend-icon="motorcycle"
                                                            required
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex :key="`bike ${index + 1}`" xs12 md2>
                                                        <v-select
                                                            :label="`Xe đạp #${index + 1}`"
                                                            :disabled="loading.submit || member.is_deleted"
                                                            v-model="member.bike"
                                                            :items="list_bike"
                                                            prepend-icon="motorcycle"
                                                            required
                                                        ></v-select>
                                                    </v-flex>
                                                </template>
                                            </template>
                                        </template>
                                    </v-layout>
                                </v-container>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    outline
                                    :loading="loading.submit"
                                    :disabled="loading.submit"
                                    @click="goBack"
                                    color="primary"
                                >
                                    Trở về
                                </v-btn>
                                <v-btn
                                    v-if="form.room_state_id"
                                    :disabled="loading.submit || form_loader"
                                    :loading="loading.submit || form_loader"
                                    @click="analyzeChange"
                                    color="primary"
                                >
                                    Tiếp tục
                                </v-btn>
                            </v-card-actions>
                        </v-stepper-content>
                        <v-stepper-content v-if="current_step == 2" step="2">
                            <v-container grid-list-xs>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            label="Diễn giải thay đổi"
                                            :disabled="loading.submit"
                                            v-model="form.note"
                                            prepend-icon="event_note"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="role === 'admin'">
                                        <v-text-field
                                            label="computed_note (admin only)"
                                            :disabled="loading.submit"
                                            v-model="form.computed_note"
                                            prepend-icon="event_note"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <change-detail :change_data="form"></change-detail>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    outline
                                    :loading="loading.submit"
                                    :disabled="loading.submit"
                                    @click="goBack"
                                    color="primary"
                                >
                                    Trở về
                                </v-btn>
                                <v-btn
                                    v-if="form.room_state_id"
                                    :loading="loading.submit"
                                    :disabled="loading.submit"
                                    @click="submit"
                                    color="primary"
                                >
                                    Tạo Phiếu
                                </v-btn>
                            </v-card-actions>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </app-card>
        </v-dialog>
</div>
</template>

<script>

import api from "Api";
import { list_building } from 'Constants/db-config'
import { buildParamQuery, formatTimeServer, deepCopy } from 'Helpers'
import ChangeDetail from './ChangeDetail'
export default {
    name: "dialog-tao-phieu-thay-doi-thong-tin",
    components: {
        ChangeDetail
    },
    data(){
        return {
            dialog: false,
            form_loader: false,
            form: {
                change_id: '',
                paper_receipt_number: '',
                date_created: '',
                date_change: '',
                building: '',
                room_id: '',
                washing_machine: '',
                air_conditioner: '',
                internet: '',
                internet_data: {},
                customers: [{},{},{},{},{}],
                member_count: 0,
                change_request: {}
            },
            menu_date_created: false,
            menu_date_change: false,
            list_building,
            list_type: [
                { text: 'Xe', value: 'motorBike' },
                { text: 'Internet', value: 'internet' },
                { text: 'Máy lạnh', value: 'air_conditioner' },
                { text: 'Máy Giặt', value: 'washing_machine' },
                { text: 'Người ở', value: 'customer' },
            ],
            list_type_change: {
                motorBike: [
                    {text: 'Thêm xe', value: 'add_motorBike'},
                    {text: 'Giảm xe', value: 'remove_motorBike'},
                    {text: 'Thay đổi thông tin xe', value: 'update_motorBike'},
                ],
                internet: [
                    {text: 'Thêm internet', value: 'add_internet'},
                    {text: 'Cắt internet', value: 'remove_internet'},
                    {text: 'Thay đổi thông tin internet', value: 'update_internet'},
                ],
                air_conditioner: {
                    'ADD': 'Thêm máy lạnh',
                    'REMOVE': 'Hủy máy lạnh'
                },
                washing_machine: {
                    'ADD': 'Thêm máy giặt',
                    'REMOVE': 'Hủy máy giặt'
                },
                customer: [
                    {text: 'Thêm người ở', value: 'add_customer'},
                    {text: 'Giảm người ở', value: 'remove_customer'},
                    {text: 'Thay đổi thông tin người ở', value: 'update_customer'},
                ],
            },
            list_washing_machine: [
                {text: 'Có', value: true},
                {text: 'Không', value: false}
            ],
            list_air_conditioner: [
                {text: 'Có', value: true},
                {text: 'Không', value: false}
            ],
            list_internet: [
                {text: 'Có', value: true},
                {text: 'Không', value: false}
            ],
            list_bike: [
                {text: 'Có', value: true},
                {text: 'Không', value: false}
            ],
			rules: {
				required: value => !!value || 'Vui lòng điền thông tin này.',
                isNaturalNumber: value =>  /^[1-9]\d*$/.test(value.replace(/,/g, '')) || "Mã chứng từ phải là số",
			},
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            chosen_room_contract: null,
            current_step: 1,
            loading: {
                submit: false
            },
            loader: false,
        }
    },
	watch: {
        'form.member_count'(nv){
            this.form.member_count = nv > 5 ? 5 : nv < 1 ? 1 : this.form.member_count
        },
        'form.room_id'(nv){
            this.getRoomInfo()
        },
        "form.building": function(nv, ov) {
            if (nv) {
                if (this.form.paper_receipt_number) this.form.change_id = nv + '.' + this.form.paper_receipt_number + ".TĐ";
            }
        },
        "form.paper_receipt_number": function(nv, ov) {
            if (nv && this.form.building) {
                this.form.change_id = this.form.building + '.' + nv + ".TĐ"; 
            }
        },
    },
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        room_ids(){
            return this.rooms.filter( room => room.building === this.form.building)
        },
        role(){
            return this.$store.state.auth.role
        },
        blockEditDate() {
            return this.$store.state.app.blockEditDate
        }
    },
    methods: {
        clearInput: function (){
            this.form = {
                change_id: '',
                date_created: '',
                building: '',
                room_id: '',
                washing_machine: '',
                air_conditioner: '',
                internet: '',
                internet_data: {},
                customers: [{},{},{},{},{}],
                member_count: 0,
                old_data: {},
                date_change: '',
                change_request: {},
            }
            this.chosen_room_contract = null
            this.current_step = 1
            this.$refs.form.resetValidation()
        },
        getReceiptNewestNumber: async function (){
            this.form_loader = true
            const params = {
                receiptType: 'CHANGE',
                building: this.form.building
            }
            const query = buildParamQuery(params)
            const data = await api.getReceiptNumberNewest(query)
            if (data.status == 200 && data.data){
                const deposit_array = data.data.deposit
            }
            this.form_loader = false
        },

        getRoomInfo: async function (){
            this.loader = true
            this.form_loader = true
            this.form.date_created = ''
            this.form.date_change = ''
            this.form.washing_machine = ''
            this.form.air_conditioner = ''
            this.form.internet = ''
            this.form.internet_data = {}
            this.form.customers = [{},{},{},{},{}]
            this.form.member_count = 0
            this.form.old_data = {}
            this.form.change_request = {}
            this.chosen_room_contract = null
            this.form.room_state_id = null
            this.alert.show = false
            if (!this.form.room_id || !this.form.building){
                this.form_loader = false
                this.loader = false
                return
            }
            const params = {
                roomId: this.form.room_id,
                building: this.form.building,
                contractValid: true,
                customerValid: true,
                deviceValid: true
            }
            const query = buildParamQuery(params)
            let data = await api.getListContracts(query)
            this.loader = false
            this.form_loader = false
            if (data.status == 200 && data.data.contracts && data.data.contracts.length){
                this.chosen_room_contract = Object.assign({}, data.data.contracts[0])
                if (this.chosen_room_contract.date_schedule_out) {
                    this.form.room_state_id = null
                    this.alert.show = true
                    this.alert.text = `Phòng ${ this.form.room_id } hiện trong trạng thái trả phòng, không thể thay đổi thông tin`
                } else {
                    this.form.room_state_id  = this.chosen_room_contract.room_state_id
                    // this.form.room_state_id =  this.chosen_room_contract.listCustomers[0].room_state_id // Tạm thời
                    this.form.customers = deepCopy(this.chosen_room_contract.listCustomers)
                    // Map device vào customer
                    this.chosen_room_contract.devicesInfo.forEach(device => {
                        if (device.customer_id){
                            let customer = this.form.customers.find(cus => cus.customer_id === device.customer_id)
                            if (device.type === 'MB' && customer){
                                if (customer.motorbike){
                                    customer.motorbike += ", " + device.name.trim()
                                } else customer.motorbike = device.name.trim()

                                if (customer.motorbike_list) {
                                    customer.motorbike_list.push(device)
                                } else customer.motorbike_list = [device]
                            } else if (device.type === 'B'){
                                customer.bike = true
                                customer.bike_id = device._id
                            }
                        } else if (device.type === "AC"){
                            this.form.air_conditioner = true
                            this.form.air_conditioner_id = device._id
                        } else if (device.type === "WM"){
                            this.form.washing_machine = true
                            this.form.washing_machine_id = device._id
                        }
                    })
                    let old_data = {
                        washing_machine: this.form.washing_machine,
                        air_conditioner: this.form.air_conditioner,
                        washing_machine_id: this.form.washing_machine_id,
                        air_conditioner_id: this.form.air_conditioner_id
                    }
                    old_data.customers = deepCopy(this.form.customers)
                    this.form.old_data = Object.assign({}, old_data)
                }
            } else {
                this.alert.show = true
                this.alert.text = data.message ? data.message : `Phòng ${ this.form.room_id } hiện không thể tạo phiếu thay đổi thông tin, vui lòng kiểm tra lại thông tin phòng`
            }
        },
        analyzeChange: function (){
            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return false
            }
            if (this.form.customers.every(customer => customer.is_deleted)){
                swal.fire('Lỗi', 'Vui lòng không xóa hết khách hàng', 'error');
                return false
            }
            this.form.change_request = {}
            const add = []
            const edit = []
            const remove = []
            // Kiểm tra thay đổi máy lạnh , máy giặt
            if (this.form.washing_machine !== this.form.old_data.washing_machine){
                if (this.form.washing_machine){
                    add.push({type: "WM"})
                } else {
                    remove.push({type: "WM", device_id: this.form.washing_machine_id})
                }
            }
            if (this.form.air_conditioner !== this.form.old_data.air_conditioner){
                if (this.form.air_conditioner){
                    add.push({type: "AC"})
                } else {
                    remove.push({type: "AC", device_id: this.form.air_conditioner_id})
                }
            }
            // Kiểm tra thay đổi khách hàng
            this.form.customers.forEach(cus => {
                // trim()
                cus.motorbike = cus.motorbike ? cus.motorbike.trim() : cus.motorbike
                // TH1: KH bị xóa -> remove Customer, remove MB (nếu có), remove B (nếu có)
                if (cus.is_deleted){
                    const old_cus = this.form.old_data.customers.find(c => c.customer_id === cus.customer_id)
                    cus.is_changed_name = true
                    cus.is_changed_phone = !!old_cus.phone
                    remove.push({
                        type: "CUSTOMER",
                        customer_id: cus.customer_id
                    })
                    if (old_cus.motorbike){
                        cus.is_changed_motorbike = true
                        old_cus.motorbike_list.forEach(motorbike => {
                            remove.push({
                                type: "MB",
                                customer_id: old_cus.customer_id,
                                device_id: motorbike._id
                            })
                        })
                    }
                    if (old_cus.bike){
                        cus.is_changed_bike = true
                        remove.push({
                            type: "B",
                            customer_id: old_cus.customer_id,
                            device_id: old_cus.bike_id
                        })
                    }
                // TH2: Kiểm tra khách hàng cũ xem có thay đổi gì ko (khách cũ thì chắc chắn sẽ có customer_id)
                } else if (cus.customer_id){
                    const old_cus = this.form.old_data.customers.find(c => c.customer_id === cus.customer_id)
                    // Kiểm tra thay đổi phone, name. Nếu có thay đổi phone, name => edit customer
                    if (cus.name !== old_cus.name || (cus.phone !== old_cus.phone && (cus.phone || old_cus.phone))){
                        cus.is_changed_name = cus.name !== old_cus.name
                        cus.is_changed_phone = cus.phone !== old_cus.phone && (cus.phone || old_cus.phone)
                        edit.push({
                            type: 'CUSTOMER',
                            customer_id: cus.customer_id,
                            name: cus.name,
                            phone: cus.phone
                        })
                    }
                    // Kiểm tra thay đổi MB, B
                    if (!!cus.bike !== !!old_cus.bike){
                        cus.is_changed_bike = true
                        // Nếu khách mới có B -> add B
                        if (cus.bike){ 
                            add.push({type: "B", customer_id: cus.customer_id})
                        } else {
                            remove.push({type: "B", customer_id: cus.customer_id, device_id: cus.bike_id})
                        }
                    }
                    if (cus.motorbike !== old_cus.motorbike){
                        
                        const result_arr = this.handleMotorbike(cus.motorbike, old_cus.motorbike_list)

                        cus.motorbike = result_arr.new_list.join(", ")
                        cus.is_changed_motorbike = result_arr.add.length || result_arr.edit.length || result_arr.remove.length
                        
                        result_arr.add.forEach(device => {
                            add.push({
                                type: "MB",
                                customer_id: cus.customer_id,
                                name: device.name
                            })
                        })

                        result_arr.edit.forEach(device => {
                            edit.push({
                                type: "MB",
                                device_id: device._id,
                                customer_id: cus.customer_id,
                                name: device.name
                            })
                        })

                        result_arr.remove.forEach(device => {
                            remove.push({
                                type: "MB",
                                customer_id: cus.customer_id,
                                device_id: device._id
                            })
                        })
                        // // Nếu mới và cũ đều có MB -> đổi số xe
                        // if (cus.motorbike && old_cus.motorbike){
                        //     edit.push({
                        //         type: "MB",
                        //         device_id: cus.motorbike_id,
                        //         customer_id: cus.customer_id,
                        //         name: cus.motorbike
                        //     })
                        // } else if (cus.motorbike){
                        //     // Nếu khách mới có MB -> add MB
                        //     add.push({
                        //         type: "MB",
                        //         customer_id: cus.customer_id,
                        //         name: cus.motorbike
                        //     })
                        // } else if (old_cus.motorbike){
                        //     remove.push({
                        //         type: "MB",
                        //         customer_id: cus.customer_id,
                        //         device_id: cus.motorbike_id
                        //     })
                        // }
                    }
                } else {
                    // TH3: Khách mới được thêm vào
                    cus.is_changed_name = !!cus.name
                    cus.is_changed_phone = !!cus.phone
                    cus.is_changed_motorbike = true
                    cus.is_changed_bike = true
                    add.push({
                        type: 'CUSTOMER',
                        name: cus.name,
                        phone: cus.phone,
                        bike: cus.bike,
                        motorbike: cus.motorbike
                    })
                }
            })
            // Diễn giải:
            let description = ''
            if (add.length){
                description += 'THÊM: '
                const count_wm = add.filter(e => e.type === "WM").length
                const count_ac = add.filter(e => e.type === "AC").length
                const count_customer = add.filter(e => e.type === "CUSTOMER").length
                let count_bike = add.filter(e => e.type === "B").length
                let count_motorbike = add.filter(e => e.type === "MB").length
                if (count_customer){
                    count_bike += add.filter(e => e.type === "CUSTOMER" && e.bike).length
                    count_motorbike += add.filter(e => e.type === "CUSTOMER" && e.motorbike).length
                }
                count_customer ? description += `${count_customer} khách hàng, ` : ''
                count_motorbike ? description += `${count_motorbike} xe máy, ` : ''
                count_bike ? description += `${count_bike} xe đạp, ` : ''
                count_wm ? description += `${count_wm} máy giặt, ` : ''
                count_ac ? description += `${count_ac} máy lạnh, ` : ''
                description = description.slice(0, -2) + '. '
            }
            if (edit.length){
                description += 'CHỈNH SỬA THÔNG TIN: '
                const count_customer = edit.filter(e => e.type === "CUSTOMER").length
                const count_motorbike = edit.filter(e => e.type === "MB").length
                count_customer ? description += `${count_customer} khách hàng, ` : ''
                count_motorbike ? description += `${count_motorbike} xe máy, ` : ''
                description = description.slice(0, -2) + '. '
            }
            if (remove.length){
                description += 'XÓA: '
                const count_wm = remove.filter(e => e.type === "WM").length
                const count_ac = remove.filter(e => e.type === "AC").length
                const count_customer = remove.filter(e => e.type === "CUSTOMER").length
                const count_bike = remove.filter(e => e.type === "B").length
                const count_motorbike = remove.filter(e => e.type === "MB").length
                count_customer ? description += `${count_customer} khách hàng, ` : ''
                count_motorbike ? description += `${count_motorbike} xe máy, ` : ''
                count_bike ? description += `${count_bike} xe đạp, ` : ''
                count_wm ? description += `${count_wm} máy giặt, ` : ''
                count_ac ? description += `${count_ac} máy lạnh, ` : ''
                description = description.slice(0, -2) + '. '
            }
            this.form.note = description
            this.form.computed_note = description
            this.form.change_request.add = add.slice(0)
            this.form.change_request.remove = remove.slice(0)
            this.form.change_request.edit = edit.slice(0)
            this.current_step = 2
        },
        handleMotorbike(cus_motorbike_new, cus_motorbike_old_arr){
            let new_list = cus_motorbike_new ? cus_motorbike_new.split(",").filter(name => name) : [];
            const old_list = cus_motorbike_old_arr ? cus_motorbike_old_arr : []

            let add = [], edit = [], remove = [];
            new_list = new_list.map(name => name.trim())
            new_list.forEach(name => {
                const found_motorbike = old_list.find(device => device.name == name)
                if (!found_motorbike) add.push({ name })
            })

            old_list.forEach(device => {
                const found_motorbike = new_list.find(name => name == device.name)
                if(!found_motorbike) remove.push(device)
            })

            remove.forEach((device, i) => {
                if (add[i]){
                    edit.push({ ...device, name: add[i].name });
                    remove[i] = null
                    add[i] = null
                }
            })
            add = add.filter(item => item)
            remove = remove.filter(item => item)
            edit = edit.filter(item => item)

            return { add, edit, remove, new_list }
        },
        async submit () {
            this.loading.submit = true
            this.form_loader = true
            const postData = {
                change_id: this.form.change_id,
                room_id: this.form.room_id,
                building: this.form.building,
                room_state_id: this.form.room_state_id,
                old_data: this.form.old_data,
                date_change: new Date(this.form.date_change),
                date_created: new Date(this.form.date_created),
                note: this.form.note,
                computed_note: this.form.computed_note,
                contract_id: this.chosen_room_contract.contract_id_str,
                change_request: this.form.change_request
            }
            let data = await api.createReceiptChange(postData)
            if (data.status == 200){
                this.dialog = false
                this.$emit("getData")
                this.clearInput()
                swal.fire('Thành công', 'Tạo thành công phiếu thay đổi thông tin', 'success')
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
            this.loading.submit = false
            this.form_loader = false
        },
        addMember: function (){
            if (this.form.customers.length < 10){
                this.form.customers.push({})
            }
        },
        removeMember: function (index){
            if (this.form.customers[index].customer_id){
                if (confirm('Bạn có chắc chắn muốn xóa thành viên này?')){
                    this.$set(this.form.customers[index], "is_deleted", true)
                }
            } else {
                this.form.customers.splice(index, 1)
            }
        },
        undoRemove: function (index){
            this.form.customers[index].is_deleted = false
        },
        goBack: function (){
            if (this.current_step === 2)
                this.current_step = 1
            else {
                this.dialog = false
                this.clearInput()
            }
        }
    }
}
</script>

<style scoped>
    table {
        border-collapse: collapse;
        width: 80%;
        max-width: 800px
    }
    th {
        padding: 8px;
        border-bottom: 1px solid #ddd;
    }
    td {
        padding: 6px
    }
    .cell-fit {
        width:1%;
        white-space:nowrap;
    }
    .border-top {
        padding-top: 9px;
        border-top: 1px solid #ddd;
    }
    .hightlight-row {
        background-color: #ddfbe6;
    }
</style>
